import { Component, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass } from '@angular/common';

import { BaseBtnGroupComponent } from '../base-btn-group';

@Component({
    selector: 'app-optimization-settings-travel-time-duration-btn-group',
    templateUrl: './optimization-settings-travel-time-duration-btn-group.component.html',
    styleUrls: ['./optimization-settings-travel-time-duration-btn-group.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OptimizationSettingsTravelTimeDurationBtnGroupComponent),
            multi: true
        }
    ],
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptimizationSettingsTravelTimeDurationBtnGroupComponent extends BaseBtnGroupComponent {
    public readonly options: Array<number> = [0, 5, 10, 15, 20, 25, 30];
}
